import * as React from 'react';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import {
  PickersDay,
  pickersDayClasses,
  PickersDayProps,
} from '@mui/x-date-pickers';

export class CustomDateFns extends AdapterDateFns {
  getWeekdays = () => {
    return ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  };
}

export default function CustomDateRangePicker(props: any) {
  const [open, setOpen] = React.useState(false);

  const popOverSx = {
    top: '40px !important',
    left: '36px !important',
  };

  const renderWeekPickerDay = (
    date: Date,
    selectedDates: Array<Date | null>,
    pickersDayProps: PickersDayProps<Date>,
  ) => {
    return (
      <PickersDay
        {...pickersDayProps}
        sx={{
          [`&&.${pickersDayClasses.selected}`]: {
            backgroundColor: '#EDE9F5',
            borderRadius: '6px',
            color: '#17052D',
          },
          [`&&.${pickersDayClasses.today}`]: {
            border: '0px',
          },
          ':hover': {
            borderRadius: '6px',
          },
        }}
      />
    );
  };

  return (
    <LocalizationProvider dateAdapter={CustomDateFns}>
      <DatePicker
        value={props.value}
        dayOfWeekFormatter={(day) => day}
        inputFormat="dd/MM/yyyy"
        open={open}
        onOpen={() => setOpen(true)}
        onClose={() => setOpen(false)}
        onChange={(newValue) => {
          props.setValue(newValue);
        }}
        renderDay={renderWeekPickerDay}
        PopperProps={{ sx: popOverSx }}
        PaperProps={{ sx: { borderRadius: '24px' } }}
        renderInput={({ inputRef, inputProps }) => (
          <input
            readOnly
            className="custom-datepicker-input"
            style={props.customInputStyle}
            ref={inputRef}
            {...inputProps}
            onClick={() => setOpen(true)}
          />
        )}
      />
    </LocalizationProvider>
  );
}
